import { useState } from "react";
import { useSnackbar } from "$utils/useSnackbar";
import JImportModal from "$components/JImportModal/JImportModal";
import { ImportType } from "$types/import/ImportType";
import { snackbarSuccessOptions } from "$utils/SnackbarOptions";
import { ButtonImportList } from "./ButtonImportList";
import { useDataPagination } from "$components/DataTable";
import useAuth from "$hooks/useAuth";

type Props = {
  importType: ImportType;
  dataName: string;
  buttonTexts: {
    importButtonText: string;
    updateButtonText?: string;
  };
  title: string;
  additionalFilters?: any;
  isFeminine?: boolean;
  disabled?: boolean;
  contextId?: string;
};

export const ImportButtonWithModal = ({
  importType,
  dataName,
  buttonTexts,
  title,
  additionalFilters,
  isFeminine,
  disabled,
  contextId,
}: Props) => {
  const [showImportModal, setShowImportModal] = useState<boolean>(false);
  const [showImportEditModal, setShowImportEditModal] =
    useState<boolean>(false);
  const [openSnackbar] = useSnackbar(snackbarSuccessOptions);
  const { isClient } = useAuth();

  // Check if we're inside a DataTableProvider context
  let filters = {};
  try {
    // This could throw an error if not in a DataTableProvider
    const dataPagination = useDataPagination();
    filters = dataPagination?.filters || {};
  } catch {
    console.error(
      "ImportButtonWithModal: Not inside a DataTableProvider context"
    );
  }

  const buttonList = [
    {
      onClick: () => setShowImportModal(true),
      text: buttonTexts.importButtonText,
      isUpdate: false,
    },
  ];

  if (buttonTexts?.updateButtonText && !isClient()) {
    buttonList.push({
      onClick: () => setShowImportEditModal(true),
      text: buttonTexts.updateButtonText,
      isUpdate: true,
    });
  }

  return (
    <>
      <ButtonImportList
        disabled={disabled}
        buttonList={buttonList}
        title={title}
      />
      <JImportModal
        showImportModal={showImportModal}
        setShowImportModal={setShowImportModal}
        type={importType}
        dataName={dataName}
        openSnackbar={openSnackbar}
        isFeminine={isFeminine}
        pastParticiple="ajouté"
        validationLabel="Ajouter"
        contextId={contextId}
      />
      <JImportModal
        showImportModal={showImportEditModal}
        setShowImportModal={setShowImportEditModal}
        type={`${importType}-update` as ImportType}
        dataName={dataName}
        openSnackbar={openSnackbar}
        canExportData
        filters={{
          ...filters,
          ...additionalFilters,
        }}
        isFeminine={isFeminine}
        pastParticiple="modifié"
        validationLabel="Modifier"
        contextId={contextId}
      />
    </>
  );
};
